module.exports = __webpack_public_path__ + "img/cr.82345a31.svg";